function ez_portfolioSlider() {

    var slider = $('._js-portfolio-slider');

    if ( slider.length) {
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _arrow-left"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _arrow-right"><use xlink:href="#arrow-right"></use></svg></button>',
            dots: false,
            variableWidth: true,
            infinite: true,
            responsive : [
                {
                    breakpoint: 767,
                    settings : {
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });

    }

}